import { useCallback } from 'react';
import { App, Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { useRenameAGMutation } from 'entities/accessGroup';

import NameInput from '../ui/NameInput/NameInput';

export const useRenameModal = (): ((id: string, name: string) => void) => {
  const { modal } = App.useApp();
  const { t } = useTranslation('AccessGroup');

  const { mutateAsync: renameAGMutation } = useRenameAGMutation();

  const openRenameModal = useCallback(
    (id: string, name: string): void => {
      const instance = modal.confirm({
        title: `${t('RenameModal.title')} ${name}`,
        transitionName: '',
        centered: true,
        closable: true,
        okButtonProps: { htmlType: 'submit' },
        cancelText: t('RenameModal.cancelButton'),
        okText: t('RenameModal.confirmButton.text'),
        onOk: () => {
          return Promise.reject();
        },
        modalRender: (dom) => (
          <Form
            initialValues={{ name }}
            onFinish={({ name: newName }) => {
              const trimmedName = newName.trim();
              instance.update({
                okButtonProps: { loading: true },
              });
              renameAGMutation(
                { id, name: trimmedName },
                {
                  onSettled: () => instance.destroy(),
                },
              );
            }}
          >
            {dom}
          </Form>
        ),
        content: <NameInput />,
      });
    },
    [renameAGMutation, modal, t],
  );

  return openRenameModal;
};
